/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App
 */
// Composables
import { createPinia } from 'pinia'
import { createApp } from 'vue'

// Plugins
import { globallyRegisterDesignSystemComponents } from '@/design-system/register-components'
import { registerPlugins } from '@/plugins'

// Custom fonts
import '@/plugins/styles/fonts.scss'

import App from './App.vue'

// Drop legacy bearer token persisted before HttpOnly auth cookies.
globalThis.localStorage.removeItem('user-token')

const app = createApp(App)
const pinia = createPinia()

async function init () {
  await registerPlugins(app)
  globallyRegisterDesignSystemComponents(app)

  // Both of those env vars come from vue.config.js because they're computed
  console.info(`closd-front version ${__APP_VERSION__} rev ${__APP_REVISION__}`)

  app.use(pinia)
  app.mount('#app')
}

init()
